import { useContext } from 'react';

import ModalContext from './ModalContext';

import styled from 'styled-components';
import { defaultTheme } from '@/theme';

type ModalFooterProps = {
  children: React.ReactNode;
  justify?: React.CSSProperties['justifyContent'];
  columnGap?: number;
  padding?: 'sm' | 'md' | 'lg';
};

const PADDING_MAP = {
  sm: '8px 24px 24px 8px',
  md: '8px 24px 24px 12px',
  lg: '8px 24px 24px 24px',
};

const ModalFooter = ({ children, justify = 'flex-end', columnGap = 8, padding = 'md' }: ModalFooterProps) => {
  const { showFooterBorder } = useContext(ModalContext);
  return (
    <ModalFooterContainer
      $justify={justify}
      $columnGap={columnGap}
      $padding={padding}
      $bc={showFooterBorder ? defaultTheme.mantineColors.gray[3] : undefined}
    >
      {children}
    </ModalFooterContainer>
  );
};

const ModalFooterContainer = styled.div<{
  $justify?: React.CSSProperties['justifyContent'];
  $columnGap?: number;
  $padding: 'sm' | 'md' | 'lg';
  $bc?: string;
}>`
  display: flex;
  justify-content: ${({ $justify }) => $justify};
  align-items: center;
  padding: ${({ $padding }) => PADDING_MAP[$padding]};
  ${({ $columnGap }) => $columnGap && `column-gap: ${$columnGap}px;`}
  border-top: ${({ $bc }) => ($bc ? `1px solid ${$bc}` : 'none')};
`;

export default ModalFooter;
